import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './ui/Header.jsx';
import Page from './ui/Page.jsx';
import Footer from './ui/Footer.jsx';
import Login from './ui/Login.jsx';
import ChangePassword from './ui/ChangePassword.jsx';
import './App.css';

function AppContent() {
  const { user, loading, challengeName } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-center">
          <svg className="animate-spin h-12 w-12 text-white mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="mt-4 text-white text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  // Show password change form if required
  if (challengeName === 'NEW_PASSWORD_REQUIRED') {
    return <ChangePassword />;
  }

  if (!user) {
    return <Login />;
  }

  return (
    <div className="min-h-full">
      <Header />
      <main className="-mt-32">
        <div className="mx-auto max-w-8xl px-4 pb-12 sm:px-6 lg:px-24">
          <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6">
            <Page />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
